import { goalText, type Rank } from "../src/domain/ranks";
import { titleCase } from "./describe";

const HEX: Record<string, string> = {
  black: "#000000", dark_blue: "#0000AA", dark_green: "#00AA00", dark_aqua: "#00AAAA", dark_red: "#AA0000",
  dark_purple: "#AA00AA", gold: "#FFAA00", gray: "#AAAAAA", dark_gray: "#555555", blue: "#5555FF", green: "#55FF55",
  aqua: "#55FFFF", red: "#FF5555", light_purple: "#FF55FF", yellow: "#FFFF55", white: "#FFFFFF",
};

export function colorHex(color: string): string {
  return HEX[color] ?? HEX.white;
}

export function rankPerks(rank: Rank): string[] {
  return [
    `${titleCase(rank.color)} name tag [${rank.name}]`,
    ...(rank.particle ? [`${titleCase(rank.particle)} trail`] : []),
    ...rank.effects.map((e) => `${titleCase(e)} always on`),
    ...(rank.glow ? ["Glows through walls"] : []),
    ...(rank.kit.length ? [`Daily kit: ${rank.kit.map((k) => `${k.count} ${titleCase(k.item)}`).join(", ")}`] : []),
  ];
}

export function rankGoalText(rank: Rank): string {
  return goalText(rank.goal);
}
